import {assert} from '@appscience/utils'
import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export const exportStatusesAtom = createPrimitiveAtom<
  Record<string, TitleWithId>
>({})

export async function updateExportStatusesAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getExportStatuses()
  const record = indexBy(x => x.id, data)
  dispatch(exportStatusesAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}

export function getExportStatusesTitle(id: string) {
  return (
    assert(
      exportStatusesAtom.getState()[id],
      `ExportStatusesAtom error: export statuses with id "${id}" not found`,
    )?.title || ''
  )
}
